import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Loader2, WifiOff } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function ProtectedRoute({ children, adminOnly = false }) {
  const { user, ready, offline, retry } = useAuth();

  if (!ready || (user === null && !offline)) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <Loader2 className="w-6 h-6 animate-spin text-zinc-500" />
      </div>
    );
  }

  // Unreachable server. Sending the user to the login screen here would be a
  // lie — they are not signed out, and signing in again would fail the same
  // way. Offer the retry instead.
  if (offline) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background px-6">
        <div className="text-center max-w-sm">
          <WifiOff className="w-6 h-6 text-zinc-500 mx-auto mb-4" />
          <p className="font-app text-lg font-semibold mb-1">Cannot reach Catalina</p>
          <p className="text-sm text-muted-foreground mb-6">
            Your session is still active. This is a connection problem, not a sign-out.
          </p>
          <Button onClick={retry} variant="outline" className="border-border">
            Try again
          </Button>
        </div>
      </div>
    );
  }

  if (!user) return <Navigate to="/login" replace />;
  if (adminOnly && user.role !== "admin") return <Navigate to="/dashboard" replace />;
  return children;
}
